module.exports = __webpack_public_path__ + "img/shahnawaz-pro.b9304105.jpg";